import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

export const StepHeader = ({ bg1, bg2, bg3, title1, title2, title3 }) => {
  return (
    // <Container fluid className="d-flex flex-column  col-md-12 col-sm-12">
    <div className="stepper col-11 col-md-11">
      <div
        className="step"
        style={{
          backgroundColor: bg1 ? "lightblue" : "",
          color: bg1 ? "#fff" : "",
        }}
      >
        <div className="step-label">{title1}</div>
        <div className="step-number">1</div>
      </div>

      <div
        className="step"
        style={{
          backgroundColor: bg2 ? "lightblue" : "",
          color: bg2 ? "#fff" : "",
        }}
      >
        <div className="step-label">{title2}</div>
        <div className="step-number">2</div>
      </div>

      <div
        className="step"
        style={{
          backgroundColor: bg3 ? "lightblue" : "",
          color: bg3 ? "#fff" : "",
        }}
      >
        <div className="step-label">{title3}</div>
        <div className="step-number">3</div>
      </div>
    </div>
    // </Container>
  );
};
